var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFeedback = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "feedback_svg__cls-1",
  d: "M5.91 14.49a1.14 1.14 0 0 1-.86-.39l-1.33-1.5A2.53 2.53 0 0 1 1.29 10V5.14a2.53 2.53 0 0 1 2.4-2.63h8.62a2.53 2.53 0 0 1 2.4 2.63V10a2.53 2.53 0 0 1-2.4 2.63H8.1L6.77 14.1a1.16 1.16 0 0 1-.86.39ZM3.53 3.6A1.31 1.31 0 0 0 2.35 5v5a1.32 1.32 0 0 0 1.18 1.42h.62l1.68 1.89 1.68-1.89h5A1.32 1.32 0 0 0 13.65 10V5a1.31 1.31 0 0 0-1.18-1.4Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "feedback_svg__cls-1",
  cx: 8,
  cy: 7.58,
  r: 0.92
}), /*#__PURE__*/React.createElement("circle", {
  className: "feedback_svg__cls-1",
  cx: 10.82,
  cy: 7.58,
  r: 0.92
}), /*#__PURE__*/React.createElement("circle", {
  className: "feedback_svg__cls-1",
  cx: 5.19,
  cy: 7.58,
  r: 0.92
}))));

export default SvgFeedback;